var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 62,
    viewBox: "0 0 85 62",
    fill: "none",
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.79224 61H83.5974V1H8.79224V31V61Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path1",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0779 26.0131V53.2079H75.8052V26.0131H61H43.0779Z",
    fill: "#845EC2",
    id: "path2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 26.0131V53.2079H33.7273V26.0131H17.3636H1Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path3",
    style: {
      fill: "none"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79224 9.18176H83.5974",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79224 1H83.5974",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.445962,34.1169 H 25.7797",
    stroke: "#bdcad1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.445962,39.5713 H 22.707413",
    stroke: "#bdcad1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.445962,45.0259 H 25.7797",
    stroke: "#bdcad1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.b210c226839d4af7949c08ae32e7b3b4.svg";
export { ForwardRef as ReactComponent };